import Link from 'next/link';

import { STitle } from './styled';

export interface IProps {
    title: string,
    href?: string,
    isPromo?: boolean,
    onClickHandler?: (menuType: 'Main' | 'Right', title: string) => void,
    className?: string,
}

const Title = ({ title, href, isPromo = false, onClickHandler, className }: IProps): JSX.Element => {
    return (
        <>
            {(href && onClickHandler)
                ? <Link href={href} prefetch={false} passHref>
                    <a className={className} onClick={() => onClickHandler('Main', title)}>
                        <STitle isPromo={isPromo}>{title}</STitle>
                    </a>
                </Link>
                : <STitle isPromo={isPromo} className={className}>{title}</STitle>
            }
        </>
    );
};

export default Title;
